export default __webpack_public_path__ + "static/media/game_analyze_2.da38f58b.png";